// extracted by mini-css-extract-plugin
export var apolloLogo = "ArHomepageLogos-module--apolloLogo--YM1sT";
export var axisLogo = "ArHomepageLogos-module--axisLogo--7q2oH";
export var container = "ArHomepageLogos-module--container--uyIkZ";
export var locktonLogo = "ArHomepageLogos-module--locktonLogo--AjS4J";
export var logo = "ArHomepageLogos-module--logo--Cb3k7";
export var logos = "ArHomepageLogos-module--logos--x1F4a";